<template>
  <div>

    <nav class="nav nav-left flex flex-col" :class="{ 'collapsed': collapsed }">
      <p class="text-center text-sm py-2" v-show="!collapsed">Administration</p>

      <ul class="root select-none">
        <li
          v-for="(route, i) in administrationRoutes"
          class="has-submenu"
          :class="{
            'root-active': route.active,
            'root-open': (route.active && !collapsed) || openParents.indexOf(route.name) !== -1
          }"
          :key="'menu-routes-' + i"
          @click.stop="parentClick(route)"
        >
          <a class="py-4 block font-bold pl-2 cursor-pointer" :class="{'active': route.active}">
            <i :class="route.meta.icon" v-if="route.meta.icon"></i>
            <span class="ml-3" v-show="!collapsed">{{ route.meta.title }}</span>
          </a>
          <ul class="sub text-sm" v-if="route.children && route.children.length">
            <li class="font-bold border-b border-theme-darker py-3 px-4 text-lg" v-if="collapsed">
              <span>{{ route.meta.title }}</span>
            </li>
            <li v-for="(child, j) in route.children" :key="route.name + '-children-routes' + j" >
              <a
                :class="{'active': child.active}"
                @click.stop="go(path.join('/administration/', route.path, child.path))"
                v-if="typeof child.meta.nav === 'undefined' || child.meta.nav === true"
              >
                <!-- <span class="mr-1" v-if="child.active">
                  <i class="fas fa-caret-right"></i>
                </span> -->
                <span>{{ child.meta.title }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>

      <div
        class="text-center bg-theme-300 light:bg-theme-500 border-t border-theme-200 light:border-theme-600 py-4 mt-auto cursor-pointer"
        @click="setCollapsed(!collapsed)"
      >
        <span v-if="collapsed">
          <i class="fas fa-angle-double-right" v-if="collapsed"></i>
        </span>
        <span v-else>
          <i class="fas fa-angle-double-left mr-1"></i>
          <span>Collapse menu</span>
        </span>
      </div>
    </nav>

  </div>
</template>


<script>
import path from 'path'
import _ from 'lodash'
import routes from '@/router/routes'

export default {
  data() {
    return {
      path,
      routes,
      testPage: 'one',
      collapsed: false,
      collapsedMaxWidth: 768,
      delay: {
        resize: {
          d: null,
          t: 100,
        }
      },
      openParents: [],
    }
  },
  computed: {
    administrationRoutes() {
      let children = _.cloneDeep(this.routes.filter(r => r.name.split('.')[0] === 'administration')[0].children)

      // $getAllowedRoutes mutates parameter!
      children = this.$getAllowedRoutes(children)

      children.map(c => c.uid = c.name.replace('.', '-'))
      this.setActive(children)
      return children
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkSize)
    this.checkSize()
  },
  destroyed() {
    window.removeEventListener('resize', this.checkSize)
  },
  methods: {
    go(to) {
      if (this.collapsed) {
        this.openParents = []
      }
      this.$router.push(to)
    },
    parentClick(route) {
      if (!route.children || !route.children.length) {
        // if no children
        this.$router.push(path.join('/administration/', route.path))
        return
      }
      // open parent
      let i = this.openParents.indexOf(route.name)
      if (i === -1) {
        if (this.collapsed) {
          this.openParents = []
        }
        this.openParents.push(route.name)
      } else {
        this.openParents.splice(i, 1)
      }
    },
    checkSize() {
      clearTimeout(this.delay.resize.d)
      this.delay.resize.d = setTimeout(() => {
        const width = document.documentElement.clientWidth
        this.setCollapsed(width < this.collapsedMaxWidth)
      }, this.delay.resize.t)
    },
    setCollapsed(collapsed) {
      this.collapsed = collapsed
      if (this.collapsed) {
        this.openParents = []
      }
      this.$EventBus.$emit('collapsedLeftMenu', collapsed)
    },
    setActive(routes) {
      for (let i in routes) {
        let route = routes[i]
        route.active = false
        if (this.$route.name === route.name) {
          route.active = true
        }
        if (route.children) {
          if (this.$route.name.indexOf(route.name) === 0) {
            route.active = true
          }
          this.setActive(route.children)
        }
      }
    },
  }
}
</script>
